"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator = "https://github.com/jpmonette/feed";
//# sourceMappingURL=index.js.map